import * as React from "react";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { Row, Col } from "react-flexbox-grid";
import Button from "material-ui/Button";
import { ExperienceType } from "../../../models/enums";
import { EducationExperience } from "../../../models/profile";
import { AddGraduationDlg } from "../addEditNavBtns";

@observer
export default class ResumeNavBtns extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  showGraduationDialog = (): boolean => {
    const profStore = this.props.store.profileStore;
    const ndx = profStore.parseStep - 2;
    if ((profStore.resumeSrc === profStore.resumeData.educations[ndx - profStore.resumeData.jobs.length]) && !profStore.resumeData.educations[ndx - profStore.resumeData.jobs.length]["grad"]) {
      this.props.store.viewState.setShowGraduationDlg(true);
      return true;
    } else {
      return false;
    }
}

  confirmGraduation = (): void => {
    this.props.store.viewState.setShowGraduationDlg(false);
    this.props.store.profileStore.incrementParseStep();
  }

  increment = (): void => {
    if (!this.showGraduationDialog()) {
      this.props.store.profileStore.incrementParseStep();
    }
  }

  render(): JSX.Element {
    const prevStr: string = this.props.store.localization.fields.resume.prev;
    const nextStr:string = this.props.store.localization.fields.resume.next;
    return <Row >
      <Col xs={12} >
        <div style={{marginTop:"12px", textAlign:"center"}}>
        <Button onClick={this.props.store.profileStore.decrementParseStep} raised color="secondary" aria-label="add">{prevStr}</Button>
        <span>&nbsp;&nbsp;</span>
        <Button onClick={this.increment} raised color="secondary" aria-label="add">{nextStr}</Button>
          </div>
      </Col>
      <AddGraduationDlg store={this.props.store} save={this.confirmGraduation} />
    </Row>
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/resumeNavBtns/index.tsx